import React, { useState, useEffect } from "react";
import Input from "react-phone-number-input/input";
import "react-phone-number-input/style.css";
import moment from "moment";
import Cookies from "js-cookie";

function ContactForm({
  onSubmit,
  initialData,
  showTimeField = true,
  onBack,
  showNavigation = false,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTime, setSelectedTime] = useState(initialData?.selectedTime || null);
  const [utmParams, setUtmParams] = useState({
    campaign: null,
    utmSource: null,
    utmMedium: null,
    utmCampaign: null,
    utmContent: null,
    utmTerm: null,
  });
  const [endTime, setEndTime] = useState("");
  const [formValues, setFormValues] = useState(initialData || {
    fname: "",
    lname: "",
    email: "",
    number: "",
  });
  const [errors, setErrors] = useState({
    fname: "",
    lname: "",
    email: "",
    number: "",
  });
  useEffect(() => {
 
      console.log("Updated endTime in contact form:", endTime);
 
  }, [endTime]);
  useEffect(() => {
    if (initialData) {
      setFormValues((prevValues) => ({
        ...prevValues,
        ...initialData,
      }));
      if (initialData.selectedTime) {
        setSelectedTime(initialData.selectedTime);
      }
    }
  }, [initialData]);

   const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate time selection when time controls are visible
    if (showTimeField && !selectedTime) {
      return;
    }

    setIsLoading(true);

    let valid = true;
    const newErrors = { fname: "", lname: "", email: "", number: "" };

    if (formValues.fname.trim() === "") {
      newErrors.fname = "First Name is required";
      valid = false;
    }
    if (formValues.lname.trim() === "") {
      newErrors.lname = "Last Name is required";
      valid = false;
    }
    if (formValues.email.trim() === "") {
      newErrors.email = "Email is required";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formValues.email)) {
      newErrors.email = "Email is invalid";
      valid = false;
    }
    if (formValues.number.trim() === "") {
      newErrors.number = "Phone number is required";
      valid = false;
    } else if (formValues.number.length < 12) {
      newErrors.number = "Correct Phone number is required";
      valid = false;
    } else if (formValues.number.length > 12) {
      newErrors.number = "Correct Phone number is required";
      valid = false;
    }
let newEndTime = endTime; // fallback

if (formValues.selectedTime) {
  newEndTime = moment(formValues.selectedTime, 'h:mm A').add(2, 'hours').format('h:mm A');
  setEndTime(newEndTime);
  console.log("endTime in contact form", newEndTime);
}

    const updatedFormValues = {
      fname: formValues.fname,
      lname: formValues.lname,
      email: formValues.email,
      number: formValues.number,
      dateStr: formValues.selectedClass.date,
      campaign: utmParams.campaign,
      utmSource: utmParams.utmSource,
      utmMedium: utmParams.utmMedium,
      utmCampaign: utmParams.utmCampaign,
      utmContent: utmParams.utmContent,
      dayName: formValues.selectedClass.dayName,
      startTime: formValues.selectedTime,
      endTime: newEndTime,
      formattedDate: formValues.selectedClass.formattedDate,
      hotel: formValues.selectedClass.hotel,
      street: formValues.selectedClass.street,
      lobyName: formValues.selectedClass.lobyName,
      city: formValues.selectedClass.city,
      zipcode: formValues.selectedClass.zipcode,
      state: formValues.selectedClass.state,
      hotelPhone: formValues.selectedClass.hotelPhone,
      timeOfSet: formValues.selectedClass.timeOfSet,
      locationName: formValues.selectedClass.locationName,
    };
    console.log("updatedFormValues", updatedFormValues)
    if (valid) {

const response = await fetch(
        "https://services.leadconnectorhq.com/hooks/kJOiQyFsJQQj5rYEbrCO/webhook-trigger/GYnUsPXpYZ4S6o6NVno1",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedFormValues),
        }
      );

      if (response.ok) {
        Cookies.set("UserData", JSON.stringify(updatedFormValues));
        Cookies.set("refresh", JSON.stringify(12));
   onSubmit({
        ...updatedFormValues
      });
      } else {
        // Code to handle form submission error goes here
        // console.error("Error submitting form");
      }
 
  
    } else {
      setErrors(newErrors);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setUtmParams({
      campaign: urlParams.get("campaign"),
      utmSource: urlParams.get("utm_source"),
      utmMedium: urlParams.get("utm_medium"),
      utmCampaign: urlParams.get("utm_campaign"),
      utmContent: urlParams.get("utm_content"),
      utmTerm: urlParams.get("utm_term"),
    });
  }, []);


  return (
    <form onSubmit={handleSubmit} className="modal-form">


      <div className="contact-fields">
        <label>

          <input
            type="text"
            placeholder="First Name"
            name="fname"
            value={formValues.fname}
            onChange={(event) =>
              setFormValues({ ...formValues, fname: event.target.value })
            }
          />
          {errors.fname && <div className="error">{errors.fname}</div>}
        </label>

        <label>
          <input
            type="text"
            placeholder="Last Name"
            name="lname"
            value={formValues.lname}
            onChange={(event) =>
              setFormValues({ ...formValues, lname: event.target.value })
            }
          />
          {errors.lname && <div className="error">{errors.lname}</div>}
        </label>

        <label>
          <input
            type="email"
            placeholder="Email"
            name="email"
            value={formValues.email}
            onChange={(event) =>
              setFormValues({ ...formValues, email: event.target.value })
            }
          />
          {errors.email && <div className="error">{errors.email}</div>}
        </label>

        <label>
          <Input
            country="US"
            international
            withCountryCallingCode
            name="number"
            placeholder="Number"
            value={formValues.number}
            onChange={(value) => setFormValues({ ...formValues, number: value })}
          />
          {errors.number && <div className="error">{errors.number}</div>}
        </label>
      </div>

      <div className="submit-form">


        {showNavigation ? (
          <div className="modal-form-actions">
            {onBack && (
              <button
                type="button"
                className="class-modal-submit"
                onClick={onBack}
              >
                ← PREV
              </button>
            )}
            <button type="submit" className="class-modal-submit" disabled={isLoading}>
              {isLoading ? 'Loading...' : "Next →"}
            </button>
          </div>
        ) : (
          <button type="submit" className="class-modal-submit" disabled={isLoading}>
            {isLoading ? 'Loading...' : "Next →"}
          </button>
        )}
      </div>
    </form>
  );
}

export default ContactForm;
